
// 首页
import Home from './Home'
const Api = Object.assign({},Home)
export default Api

